import React, { Fragment, h } from "preact";
import {AppPage} from '../../_common/components/app-page'
import {CF} from '../../_common/layout'
import {t} from '../../_i18n'
import {useHistory} from 'react-router'
import {connect} from "react-redux";
import {useEffect, useState} from "preact/hooks";
import {getEnrollPostponementStatus, postponeEnroll, resumeEnroll} from "../../_rx/expediente/actions";
import {Link} from "react-router-dom";
import EnrollsList from "./EnrollsList";
import PostponementModal from "./PostponementModal";


function EnrollPostponement({studentId, getEnrollPostponementStatus, postponeEnroll, resumeEnroll}) {
    const [postponementStatus, setPostponementStatus] = useState([])
    const [period, setPeriod] = useState('current')
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalAction, setModalAction] = useState(null)
    const [selectedEnroll, setSelectedEnroll] = useState(null)

    const hasEnrollsInPeriod = postponementStatus[period]?.academic_programs?.some((ap) =>
        ap?.pending_formative_actions?.length > 0 || ap?.postponed_formative_actions?.length > 0
    )

    useEffect(async () => {
        const status = await getEnrollPostponementStatus(studentId);
        setPostponementStatus(status);
    }, [period, getEnrollPostponementStatus]);

    const handleChangePeriod = (newStatus) => setPeriod(newStatus);


    const openModal = (e, action) => {
        setSelectedEnroll(e)
        setModalAction(action)
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setModalAction(null)
        setSelectedEnroll(null)
        setIsModalOpen(false)
    }

    const handleAction = async (studentId, enrollId) => {
        if (modalAction === 'postpone') {
            await postponeEnroll(studentId, enrollId);
        } else if (modalAction === 'resume') {
            await resumeEnroll(studentId, enrollId);
        }
        const updatedStatus = await getEnrollPostponementStatus(studentId);
        setPostponementStatus(updatedStatus);
        closeModal();
    };

    return (
        <CF className="max-width-980">
            <div>
                <p>{t('enroll_postponement_desc')}</p>
            </div>
            <div className="tabs-container">
                <div className="inline">
                    <Link to="#" className={period === 'current' ? 'selected' : ''}
                          onClick={() => handleChangePeriod('current')}>{t('Semestre actual')}</Link>
                </div>
                <div className="inline">
                    <Link to="#" className={period === 'next' ? 'selected' : ''}
                          onClick={() => handleChangePeriod('next')}>{t('Próximo semestre')}</Link>
                </div>
            </div>
            {hasEnrollsInPeriod ?
                <Fragment>
                    <PostponementModal
                        visible={isModalOpen}
                        studentId={studentId}
                        enroll={selectedEnroll}
                        action={modalAction}
                        period={period}
                        onAction={(studentId, enrollId) => handleAction(studentId, enrollId)}
                        onClose={closeModal}
                    />
                    <EnrollsList
                        type={'pending'}
                        enrollsInPeriod={postponementStatus[period]}
                        onAction={(e) => openModal(e, 'postpone')}
                    />
                    <EnrollsList
                        type={'postponed'}
                        enrollsInPeriod={postponementStatus[period]}
                        onAction={(e) => openModal(e, 'resume')}
                        className={'m-x2-top'}
                    />
                </Fragment>
                :
                <div>
                    <p>{t('no_enrolls_in_period')}</p>
                </div>
            }
        </CF>
    )
}

EnrollPostponement = connect(
    ({auth}) => ({
        studentId: auth.loggedUser.id,
    }),
    {getEnrollPostponementStatus, postponeEnroll, resumeEnroll})(EnrollPostponement);


export default () => {
    const history = useHistory();
    return (
        <AppPage
            name="aplazar-asignaturas"
            title={t('Aplazar asignaturas')}
            back={history.goBack}
            class="max-width-980">
        <EnrollPostponement/>
        </AppPage>
    );
}
